import React, { useEffect } from 'react'
import styles from "../myprofile/myprofile.module.css"
import ProfileMenu from '../../Components/profilemenu/ProfileMenu'
import EnquiryDeets from '../../Components/allEnquiresTab/EnquiryDeets'
import Myprofile from '../myprofile/Myprofile'
import { useDispatch, useSelector } from 'react-redux'
import { getBomEnquirydetailsThunk, getExcessEnquirydetailsThunk, getWizardEnquirydetailsThunk } from '../../../../Website/redux/bomSlice'
import { useLocation, useParams } from 'react-router-dom'
import VendorExcessStockDetails from '../../Components/allEnquiresTab/VendorExcessStockDetails'
import { getExcessStockdetailsThunk } from '../../../../Website/redux/excessSlice'

const VendorExcessDetails = () => {
    const dispatch = useDispatch()
    const { id } = useParams()
    

    const { stockDetails, loading, refresh } = useSelector(state => state.excess)

    useEffect(() => {
      
            dispatch(getExcessStockdetailsThunk(id))
    }, [refresh])

    console.log(stockDetails);


    return (
        <>
            <Myprofile>
                {
                    loading ?
                        <div style={{ display: 'flex', justifyContent: 'center', padding: 10,width:'100%' }}>
                            <img src="/assets/__Iphone-spinner-1.gif" alt="" style={{ width: 35, height: 35 }} />
                        </div>
                        :
                        <VendorExcessStockDetails
                            data={stockDetails}
                            enquiryId={stockDetails?._id}
                        />
                }

            </Myprofile>
        </>
    )
}

export default VendorExcessDetails